import Service from "../../service";

const FundraisingService = {
  getCampaigns: async (token, status = "", orgId = null) => {
    try {
      const params = new URLSearchParams();
      if (status) params.set("status", status);
      if (orgId) params.set("org_id", orgId);
      const query = params.toString() ? `?${params.toString()}` : "";
      return await Service.get(`/finance/v1/campaign${query}`, token);
    } catch (error) {
      throw error;
    }
  },

  getCampaign: async (id, token) => {
    try {
      return await Service.get(`/finance/v1/campaign/${id}/analytics`, token);
    } catch (error) {
      throw error;
    }
  },

  createCampaign: async (data, token) => {
    try {
      return await Service.post({
        url: `/finance/v1/campaign`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  updateCampaign: async (id, data, token) => {
    try {
      return await Service.update({
        url: `/finance/v1/campaign/${id}`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  updateCampaignStatus: async (id, status, token) => {
    try {
      return await Service.update({
        url: `/finance/v1/campaign/${id}/status`,
        data: { status },
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  postUpdate: async (id, data, token) => {
    try {
      return await Service.post({
        url: `/finance/v1/campaign/${id}/update`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  getDonors: async (id, token, page = 1, limit = 20) => {
    try {
      return await Service.get(`/finance/v1/campaign/${id}/donors?page=${page}&limit=${limit}`, token);
    } catch (error) {
      throw error;
    }
  },

  getAnalytics: async (id, token) => {
    try {
      return await Service.get(`/finance/v1/campaign/${id}/analytics`, token);
    } catch (error) {
      throw error;
    }
  },

  editUpdate: async (id, updateId, data, token) => {
    try {
      return await Service.update({ url: `/finance/v1/campaign/${id}/update/${updateId}`, data, token });
    } catch (error) { throw error; }
  },

  deleteUpdate: async (id, updateId, token) => {
    try {
      return await Service.remove({ url: `/finance/v1/campaign/${id}/update/${updateId}`, token });
    } catch (error) { throw error; }
  },

  getCampaignById: async (id, token) => {
    try {
      return await Service.get(`/finance/v1/campaign/${id}`, token);
    } catch (error) {
      throw error;
    }
  },
};

export default FundraisingService;
